<template>
  <el-row class="moon-phase-container">
    <el-col class="col-pond-details">
      <el-row>
        <div type="flex" justify="center" style="display:flex">
          <el-tooltip
            v-for="phase in moonPhases"
            :key="phase.phase"
            :content="phasesTranslation[phase.phase]"
          >
            <el-row tag="span" class="moon-phase">
              <el-col tag="span" :class="`moon-phase-shape--${phase.phase}`"></el-col>

              <el-col tag="span" class="moon-phase-date">
                <div style="width:50px">{{ phase.date.locale($i18n.locale).format("MMM DD") }}</div>
              </el-col>
            </el-row>
          </el-tooltip>
        </div>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data: function() {
    return {
      moonPhases: [],
      loading: false,
      moonPhasesNames: [
        "new-moon",
        "waxing-crescent-moon",
        "quarter-moon",
        "waxing-gibbous-moon",
        "full-moon",
        "waning-gibbous-moon",
        "last-quarter-moon",
        "waning-crescent-moon"
      ]
    };
  },
  computed: {
    phasesTranslation: function() {
      return {
        4: this.$t("Comn_full_moon"),
        6: this.$t("Comn_first_quarter"),
        0: this.$t("Comn_new_moon"),
        2: this.$t("Comn_last_quarter")
      };
    }
  },
  async mounted() {
    this.$moment.locale(this.$i18n.locale);
    this.moonPhases = this.getFourMoonPhases(this.$moment());
  },
  methods: {
    getFourMoonPhases(momentDateObj) {
      const moonPhasesObj = {};
      let year, month, day;
      let i = 0;
      while (Object.keys(moonPhasesObj).length !== 4 && i < 40) {
        year = momentDateObj.year();
        month = momentDateObj.month();
        day = momentDateObj.date();
        const phase = this.calculateMoonPhase(year, month, day);

        if (phase % 2 === 0) {
          if (moonPhasesObj[phase] == null) {
            moonPhasesObj[phase] = {
              date: this.$moment(`${year}-${month + 1}-${day}`, "YYYY-MM-DD"),
              phase,
              url: `@/assets/moon-phase-${phase}.svg`
            };
          }
        }
        momentDateObj.add(1, "days");
        i++;
      }
      const phases = Object.values(moonPhasesObj);
      phases.sort((a, b) => {
        const diff = a.date.diff(b.date);
        if (diff === 0) {
          return 0;
        } else if (diff > 0) {
          return 1;
        }
        return -1;
      });
      return phases;
    },
    calculateMoonPhase(year, month, day) {
      let c = 0;
      let e = 0;
      let jd = 0;
      let b = 0;
      if (month < 3) {
        year--;
        month += 12;
      }
      ++month;
      c = 365.25 * year;
      e = 30.6 * month;
      jd = c + e + day - 694039.09; // jd is total days elapsed
      jd /= 29.5305882; // divide by the moon cycle
      b = parseInt(jd); // int(jd) -> b, take integer part of jd
      jd -= b; // subtract integer part to leave fractional part of original jd
      b = Math.round(jd * 8); // scale fraction from 0-8 and round

      if (b >= 8) b = 0; // 0 and 8 are the same so turn 8 into 0
      return b;
    }
  }
};
</script>
<style lang="scss">
.moon-phase-container {
  .col-pond-details span.moon-phase-date {
    @include responsiveProperty(
      font-size,
      $app_font_size_v_medium,
      $app_font_size_small,
      $app_font_size_1
    );
    text-transform: capitalize;
  }
  .col-pond-details {
    text-align: center;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    span {
      font-size: 13px;
    }
    span:last-child {
      color: #3f98cb;
    }
  }
  .col-pond-details:last-child {
    border-right: unset;
  }
  .el-row.moon-phase:nth-child(n-1) {
    margin-right: 8px;
  }
  .el-col[class*="moon-phase-shape"] {
    height: 18px;
    background-size: 18px;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .moon-phase-shape--0 {
    background-image: url("../../assets/moon-phase-0.svg");
  }
  .moon-phase-shape--2 {
    background-image: url("../../assets/moon-phase-2.svg");
  }
  .moon-phase-shape--4 {
    background-image: url("../../assets/moon-phase-4.svg");
  }
  .moon-phase-shape--6 {
    background-image: url("../../assets/moon-phase-6.svg");
  }
}
</style>